// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"reading-goal_loadingContainer__5MEZB"};